// Project configuration
export const projectName = 'onboarding-webapp'
export const projectVersion = '8.0.0'
